export default "__VITE_ASSET__Me1OrL1y__"